goog.provide('el8.appchart.medsMgr');

goog.require('el8.ptdata.medOrders');
goog.require('el8.util.datecompare');
goog.require('el8.service.urls');
goog.require('el8.appservice.notifier');


el8.appchart.medsMgr = (function() {

    return {

        toggleMedicationType: function(medOrderId) {
            var medOrder = el8.ptdata.medOrders.getById(medOrderId);
            var newType = medOrder.isPrescription() ? 'otc' : 'prescription';
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+"prescriptions/"+medOrder.getId()+"/medication-type/",
                data: {medication_type: newType},
                success: function(data) {
                    el8.ptdata.medOrders.create(data)
                    
                    var thread = el8.ptdata.medOrderThreads.getById(medOrder.getThreadId());
                    el8.ptdata.medOrderThreads.trigger(EVENTS.UPDATED, thread);
                }
            });
        },

        toggleThreadPermanence: function(threadId) {
            var thread = el8.ptdata.medOrderThreads.getById(threadId);
            var currState = thread.isPermanent();
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'meds/'+threadId+'/permanence/'+
                        (currState ? '0' : '1') + '/',
                success: function(data) {
                    thread.setPermanent(data);
                    el8.ptdata.medOrderThreads.trigger(EVENTS.UPDATED, thread);
                }
            });
        },

        changeThreadStartDate: function(threadId, _newDate, callbackFn) {
            var thread = el8.ptdata.medOrderThreads.getById(threadId);
            var oldDate = thread.getStartDate();
            var newDate = el8.service.tz.newTzDate(_newDate);
            if (!el8.util.datecompare.isSameDay(newDate, oldDate)) {
                $.el8_ajax({
                    type: 'POST',
                    url: el8Globals['PATIENT_PATH']+"prescriptions/"+threadId+"/thread-start-date/",
                    data: {start_date: el8.service.tz.asServerFormatDate(newDate)},
                    success: function(data) {
                        thread.setStartDate(data);
                        el8.ptdata.medOrderThreads.trigger(EVENTS.UPDATED, thread);
                        if (callbackFn) { callbackFn(); }
                    }
                });
            }
        },

        mergeThreads: function(primaryThreadId, destinationThreadIds) {
            if (!destinationThreadIds || !destinationThreadIds.length) { return; }
            el8.appservice.notifier.notify('Merging meds together...');
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'prescriptions/'+primaryThreadId+'/merge/',
                data: { id: destinationThreadIds },
                success: function(data) {  // returns encode json of destination thread
                    for (var i=0; i<destinationThreadIds.length; i++) {
                        el8.ptdata.medOrderThreads.remove(destinationThreadIds[i], true);
                    }
                    var primaryThread = el8.ptdata.medOrderThreads.create(data['primary_thread'], true);
                    var newLatestOrderId = data['moved_order_ids'].has(primaryThread.getLatestOrderId()) ?
                        primaryThread.getLatestOrderId() : null;
                    el8.ptdata.medOrderThreads.trigger(EVENTS.MERGED, 
                        primaryThread.getId(), destinationThreadIds, 
                        data['moved_order_ids'], newLatestOrderId);
                    // Highlight in ref panel if there
                    el8.appchart.refpanel.meds.highlightThread(primaryThread.getId());
                    el8.appservice.notifier.notify('Meds merge complete.');
                }
            });
        },

        moveOrderToThread: function(moveOrderId, destinationThreadId, isPermanent, isRx) {
            el8.appservice.notifier.notify('Moving order...');
            var dict = {};
            if (destinationThreadId) { 
                dict['thread_id'] = destinationThreadId; 
            } else { 
                dict['is_permanent'] = isPermanent; 
                if (isPermanent) { dict['is_rx'] = isRx; }
            }
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('moveOrderToThread', [moveOrderId]),
                data: {'data': JSON.stringify(dict)},
                success: function(data) {
                    var newThread = el8.ptdata.medOrderThreads.create(data['new_thread'], false);
                    if (data['previous_thread']) {
                        el8.ptdata.medOrderThreads.create(data['previous_thread'], false);
                    } else if (data['deleted_previous_thread_id']) {
                        el8.ptdata.medOrderThreads.remove(data['deleted_previous_thread_id'], false);
                    }

                    // Note that the moved order will only show in the meds hx dialog
                    // at this point in the event that it is now displaying in the
                    // related threads section. That gets rendered on the client, so 
                    // should be completed at this point.
                    el8.appchart.medsHx.main.highlight([moveOrderId]);

                    // Highlight in ref panel if there
                    el8.appchart.refpanel.meds.highlightThread(newThread.getId());

                    el8.appservice.notifier.notify('Order has been moved.');
                }
            });
        },

        moveFillToOrder: function(fillId, medOrderId) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('medsHxAssignFillToOrder', [fillId, medOrderId]),
                success: function(data) {
                    var sourceOrder = el8.ptdata.medOrders.create(data['source_order'], true); // no notify
                    var newOrder = null;
                    if (data['destination_order']) {
                        newOrder = el8.ptdata.medOrders.create(data['destination_order'], true); // no notify
                        el8.ptdata.medOrderFills.trigger(EVENTS.MOVED, fillId, 
                            sourceOrder.getId(), newOrder.getId());
                    } else if (data['new_order']) {
                        newOrder = el8.ptdata.medOrders.create(data['new_order'], true); // no notify
                        el8.ptdata.medOrderFills.trigger(EVENTS.MOVED, newOrder.getThreadId());
                    }
                }
            });
        },

        acknowledgeRxDownloadThread: function(threadId, callbackFn) {
            el8.appservice.notifier.notify('Acknowledging med...');
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('medsHxAcknowledgeThread', [threadId]),
                success: function(data) {

                    el8.appservice.notifier.notify('Med acknowledged.');

                    var oldThread = el8.ptdata.medOrderThreads.remove(threadId, true);
                    // Do a custom trigger of DELETE event with an arg for medsHx to ignore it
                    el8.ptdata.medOrderThreads.trigger(EVENTS.DELETED, oldThread, {medsHxUpdate: false});

                    // Remove fills that belonged to the old thread
                    el8.ptdata.medOrderFills.removeUnsignedByThreadId(threadId);

                    // Update and trigger update on all rx download summaries that were originally unsigned
                    var summaries = data['rx_download_summaries'];
                    if (summaries && summaries.length) {
                        summaries.map(function(a) {
                            el8.ptdata.rxHistoryDownloadSummaries.create(a, false);
                        });
                    }

                    // Heavy thread gets returned. Will take care of notifications
                    // and also update orders and fills (which should be in fine state at this point);
                    // use a custom trigger so we can make both the new thread and the old rx download thread
                    // available to any listeners
                    var thread = el8.ptdata.medOrderThreads.create(data['thread'], true);
                    el8.ptdata.medOrderThreads.trigger(EVENTS.UPDATED, thread, oldThread);

                    // This can only be called from medshx (well, we'll check if it's shown),
                    // so we should just show the thread
                    if (el8.appchart.medsHx.main.isOpen()) {
                        el8.appchart.medsHx.main.show({threadId: thread.getId()});
                    }

                    if (callbackFn) { callbackFn(); }
                }
            });
        },

        acknowledgeNoMergeRxDownloadSummary: function(summaryId, callbackFn) {
            var that = this;
            if (el8.ptdata.rxHistoryDownloadSummaries.all()
                    .filter(function(a) { return !a.isSignedOff(); }).length > 1) {
                el8.uiwidget.confirm('This will sign off all fills received from any pharmacy benefits manager WITHOUT merging into the patient\'s medication list. Continue?', function() { that._doSignOffRxDownload(summaryId, false, callbackFn); });
            } else {
                that._doSignOffRxDownload(summaryId, false, callbackFn);
            }

        },

        acknowledgeRxDownloadSummary: function(summaryId, callbackFn) {
            var that = this;
            if (el8.ptdata.rxHistoryDownloadSummaries.all()
                    .filter(function(a) { return !a.isSignedOff(); }).length > 1) {
                el8.uiwidget.confirm('This will sign off and merge ALL outstanding fills received from any pharmacy benefits manager. Continue?', function() { that._doSignOffRxDownload(summaryId, true, callbackFn); });
            } else {
                that._doSignOffRxDownload(summaryId, true, callbackFn);
            }

        },

        _doSignOffRxDownload: function(summaryId, doMerge, callbackFn) {

            // Today, this will sign off all rx downloads, not just a single one, so 
            // will have somewhat confusing behavior on charts with multiple rx downloads

            var msg = doMerge ? 'Merging all fills...' : 'Signing off fills download without merging fills...';
            el8.appservice.notifier.notify(msg);
            $.el8_ajax({
                type: 'POST',
                url: doMerge ? el8.service.urls.get('medsHxSignoff') : el8.service.urls.get('medsHxSignoffNoMerge', [summaryId]),
                success: function(data) {

                    var successMsg = doMerge ? 'All fills merged.' : 'Fills download signed off without merging fills.';
                    el8.appservice.notifier.notify(successMsg);

                    // Remove all the unsigned fills, because ID's have changed or been deleted
                    el8.ptdata.medOrderFills.all().filter(function(a) {
                        return a.isRxDownload();
                    }).map(function(a) {
                        el8.ptdata.medOrderFills.remove(a, true);
                    });

                    // Remove all the unsigned orders, because ID's have changed or been deleted
                    el8.ptdata.medOrders.all().filter(function(a) {
                        return a.isRxDownload();
                    }).map(function(a) {
                        el8.ptdata.medOrders.remove(a, true);
                    });

                    // Remove all the unsigned threads, because ID's have changed or been deleted
                    el8.ptdata.medOrderThreads.all().filter(function(a) {
                        return a.isRxDownload();
                    }).map(function(a) {
                        el8.ptdata.medOrderThreads.remove(a, true);
                    });

                    // Remove all the unsigned rx history downloads from outstanding
                    el8.ptdata.rxHistoryDownloadSummaries.all().filter(function(a) {
                        return !a.isSignedOff();
                    }).map(function(a) {
                        el8.ptdata.rxHistoryDownloadSummaries.remove(a, true);
                    });

                    // Update req act and chart feed
                    el8.appchart.mainFeeds.outstanding.update();
                    el8.appchart.mainFeeds.chart.update();

                    // Update LHS threads + orders
                    el8.appchart.refpanel.meds.render(true);

                    // Trigger a refresh of the meds hx overlay, if it's open
                    // TODO For now, just clearing contents of medsHx is if it's open
                    el8.appchart.medsHx.main.clearContents();

                    // Notify visit note
                    el8.appchart.mgr.notes.markMedsReconciled(true);

                    if (callbackFn) { callbackFn(); }

                }
            });
        }

    };

})();


